import { GetData } from "contexts/DataContext";

import { Cached, DarkMode, ExitToApp, MoreVert } from "@mui/icons-material";
import { Divider, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";

import { useKeycloak } from "@react-keycloak/web";
import { GetAlertData } from "contexts/AlertContext";
import { GetColorMode } from "contexts/ThemeContext";
import React from "react";
// import { useAuth } from "react-oidc-context";
import { PinField } from "./fields/PinField";

export default function ProfileMenu(props) {
  const { keycloak } = useKeycloak();
  const { clear } = GetAlertData();
  const { clearCache, clearDataObj } = GetData();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  // const auth = useAuth();
  const { toggleColorMode } = GetColorMode();

  async function onCacheReset() {
    setAnchorEl(null);
    await clearCache();
    await clear();
    window.location.reload(false);
  }

  // const handleLogout = async () => {
  //   auth.clearStaleState();
  //   auth.removeUser();
  //   auth.signoutRedirect({ id_token_hint: auth.user?.id_token });
  // };

  async function onClearArray() {
    setAnchorEl(null);
    keycloak?.logout();
    // await handleLogout();
    // await clearDataObj();
    await clear();
  }

  return (
    <React.Fragment>
      <Tooltip title="Действия">
        <IconButton
          aria-hidden={false}
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
          }}
          sx={{
            lineHeight: 1,
            position: "absolute",
            right: "0.5rem",
            top: "0.5rem",
          }}
        >
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        id="demo-customized-menu"
        onClose={() => setAnchorEl(null)}
        open={open}
        sx={{
          ".MuiMenuItem-root": {
            gap: "6px",
            justifyContent: "flex-end",
            minHeight: "32px",
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {/* <MenuItem
          disableRipple
          onClick={() => {
            setAnchorEl(null);
            props.setOpen(true);
          }}
        >
          Изменить
          <Edit />
        </MenuItem> */}
        <MenuItem
          disableRipple
          onClick={() => toggleColorMode()}
          sx={{ justifyContent: "flex-end", minHeight: "32px" }}
        >
          Изменить тему
          <DarkMode />
        </MenuItem>
        <PinField setAnchorEl={setAnchorEl} />
        <MenuItem
          disableRipple
          onClick={() => {
            onCacheReset();
          }}
        >
          Очистить кэш
          <Cached />
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem
          disableRipple
          onClick={() => {
            onClearArray();
          }}
        >
          Выйти
          <ExitToApp />
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
